import { Component, OnInit, ViewChild } from "@angular/core";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { TokenService } from "src/app/core/services/token.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { PrintsRulesService } from "../prints-rules.service";
import { TranslateService } from "@ngx-translate/core";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { FilterConstants } from "src/app/constants/filterConstants";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { CommonService } from "src/app/core/services/common.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";

@Component({
  selector: "app-list-prints-rules",
  templateUrl: "./list-prints-rules.component.html",
  styleUrls: ["./list-prints-rules.component.scss"],
})
export class ListPrintsRulesComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  public filtersSearch = "";
  filterList = FilterConstants.printsRules;
  tableList = TableConstants.printsRules;
  routing = RoutingConstants.printsRulesRouting;
  options = TableConstants.allShowed;
  optionsheader = { style : { "min-width": "1100px" } };
  filtersTable: string;
  filtersTableJSON;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  printsRules: any[];
  
  showTableFilter: boolean = false;
  showFilterButtons: boolean = false;

  constructor(
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private printsRulesService: PrintsRulesService,
    private translateService: TranslateService,
    private tokenService: TokenService,
    private sweetAlertService: SweetAlertService,
    private commonService: CommonService
  ) {
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      this.routing.id,
      ScreenConstants.admSistemas.printRules
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
  }

  ngOnInit(): void {
    this.options.label = false;
    this.getPrintsRulesList();
  }

  getPrintsRulesList() {
    let filters = this.commonService.concatFilters(
      this.filtersTable,
      this.filtersSearch
    );
    this.sweetAlertService.sweetAlertLoading();
    this.printsRulesService.list(filters).subscribe(
      (data) => {
        this.printsRules = this.mapDataToTable(data["content"]);
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];

        if (data["content"] && data["content"].length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  mapDataToTable(data): any[] {
    data.forEach((element) => {
      element.fiDesc = element.formatosimpresion.fiDesc;
      element.tpNombre = element.tetiqueta.tpNombre;
    });

    return data;
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.getPrintsRulesList();
  }

  removeElements(ids: string[]) {
    this.printsRulesService.removePrintRule(ids).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data["mensaje"]);
        this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
          this.routing.id,
          ScreenConstants.admSistemas.printRules
        );
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.getPrintsRulesList();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  moveUpDown(value: any) {
    let move = value.move;
    let id = value.id;
    let element = this.printsRules.find((e) => e[this.routing.id] == id);
    this.printsRulesService
      .modeUpDownPrintRule(move, element[this.routing.id])
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data["mensaje"]);
          this.getPrintsRulesList();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.getPrintsRulesList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
